export * from './Locales.types';
export { default } from './Locales';
